import {CheckCircleOutlined} from '@mui/icons-material';
import WarningIcon from '@mui/icons-material/Warning';
import {Chip, Tooltip, useTheme} from '@mui/material';
import {alpha} from '@mui/material/styles';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';

import animationFile from '../../../../lotties/spinner/whiteSpinnerAnimation.json';

const SingleSourceStatusChip = ({isConnected, errorMessage = '', isTestingConnection, onTest}) => {
  const theme = useTheme();

  const getStatusText = () => {
    if (isTestingConnection) return 'Test de la connexion ...';
    return isConnected ? 'Connecté' : 'Non connecté';
  };

  const statusText = getStatusText();
  const statusChipColor = isConnected ? '#dcfce5' : '#dedede';
  const statusChipTextColor = isConnected && !isTestingConnection ? theme.palette.success.dark : 'text.secondary !important';
  const statusChipIcon = isConnected ? <CheckCircleOutlined color="success.dark" sx={{fontSize: 12}} /> : <WarningIcon color="grey.200" sx={{fontSize: 12}} />;

  return (
    <Tooltip placement="top" title={errorMessage}>
      <Chip
        icon={isTestingConnection ? <Lottie data-testid="lottie-spinner" style={{height: 16, width: 16}} loop animationData={animationFile} /> : statusChipIcon}
        onClick={isTestingConnection ? null : onTest}
        sx={{
          '&:hover': {
            backgroundColor: !isTestingConnection && statusChipColor,
            cursor: isTestingConnection ? 'not-allowed' : 'pointer'
          },
          fontWeight: 'bold',
          fontSize: 12,
          backgroundColor: isTestingConnection ? '#DEDEDE' : alpha(statusChipColor, 0.8),
          color: statusChipTextColor
        }}
        label={statusText}
        size="small"
      />
    </Tooltip>
  );
};

SingleSourceStatusChip.propTypes = {
  isConnected: PropTypes.bool.isRequired,
  isTestingConnection: PropTypes.bool.isRequired,
  onTest: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
};

export default SingleSourceStatusChip;
